const baseTitle = 'Bioseco - solutions for bird protection';

export const en = {
  "go_up": "top",
  page_titles: {
    home: baseTitle,
    products: `Products | ${baseTitle}`,
    farm: `Solution for Wind Farms | ${baseTitle}`,
    airport: `Innovative system for preventing bird-aircraft collisions | ${baseTitle}`,
    area: `Solution for ornithologists | ${baseTitle}`,
    farmPresentation: `Solution for Wind Farms | ${baseTitle}`,
    airportPresentation: `Innovative system for preventing bird-aircraft collisions | ${baseTitle}`,
    areaPresentation: `Solution for ornithologists | ${baseTitle}`,
    about: `About | ${baseTitle}`,
    blog: `Blog | ${baseTitle}`,
    contact: `Contact | ${baseTitle}`,
    auctions: baseTitle,
    projects: 'Projects co-financed by the EU',
    awards: `Awards | ${baseTitle}`,
    grants: `Grants | ${baseTitle}`,
    certificates: `Certificates | ${baseTitle}`,
    privacy: `Privacy policy | ${baseTitle}`,
    bps: `Bird Protection System for Wind Farms | ${baseTitle}`,
    afms: `Airport Fauna Monitoring System | ${baseTitle}`,
    bridgealfa: `Bridge Alfa | ${baseTitle}`,
    pmt: `Polish Technology Bridge to USA | ${baseTitle}`,
    eic: `Support in preparation of application and FS for EIC Accelerator Pilot | ${baseTitle}`,
    bps2: `Bird Protection System | ${baseTitle}`,
    pbe: `Project PBE Grant | ${baseTitle}`,
    pbe2: `Project PBE Grant 2 | ${baseTitle}`,
    ppbb: `Promotion of the Product Brand BIOSECO | ${baseTitle}`,
    offshore: `Comprehensive protection of birds around offshore wind farms | ${baseTitle}`,
    infonews: `News | ${baseTitle}`
  },
  menu: {
    home: 'Home',
    products: {
      title: 'Products',
      farms: 'For wind farm',
      airports: "For airports",
      ornithologists: "For ornithologists"
    },
    certs: 'Certificates',
    awards: 'Awards',
    grants: {
      title: 'Grants',
      bps: 'Bird Protection System for Wind Farms',
      afms: 'Airport Fauna Monitoring System',
      ba: 'Bridge Alfa',
      pmt: 'Polish Technology Bridge to USA',
      eic: 'Support in preparation of application and FS for EIC Accelerator Pilot',
      bps2: 'Bird Protection System',
      pbe: 'Project PBE Grant',
      pbe2: 'Project PBE Grant 2',
      ppbb: 'Promotion of the Product Brand BIOSECO',
      offshore: 'Comprehensive protection of birds around offshore wind farms'
    },
    news: 'News',
    about: 'About us',
    blog: "Blog",
    contact: "Contact",
    ask: "Ask question",
    english: "English",
    polish: "Polski",
    deutch: "Deutch",
    project: 'Projects co-financed by the EU'
  },
  certs: {
    headingTopText: 'Bioseco Certificates',
    seeCerts: 'See our certificates',
  },
  awards: {
    hedingTopText: 'Bioseco Awards',
    seeAwards: 'See our awards',
    list: {
      1: "Geneva-Brussels, 10.2020.<br/> Bioseco was among the winners of the Tech Tour Photonics program. ",
      2: "Warsaw, September 28, 2020.<br/>2nd place among the 50 Most Creative People in Business for Krzysztof Paszek, co-founder of Bioseco. The award was won at the tenth Jubilee Gala under the patronage of the Polish Ministry of Development, PKN Orlen SA, Google for Startups, Santander Bank Polska, the Polish Chamber of Commerce.",
      3: "Warsaw, 08.2019.<br />Bioseco among twenty companies that will change Poland according to the monthly newspaper \"My Company\".",
      4: "Warsaw, 04.2019.<br/>Bioseco - Positive Impact Startup. In the first edition of the 2019 Positive Impact Startup Report organized by Kozminski Business Hub, Bioseco was among the innovative Polish startups.",
      5: "Brussels, 2019.<br/>2018 IEEE N3XT® STAR. Bioseco is among the companies in the area of ​​innovative technologies selected by the jury of IEEE Entrepreneurship Stars, an organization under the patronage of the European Parliament.",
      6: "Brussels, 29/11/2018.<br />Winner of the prestigious EUtop50 Innovators, contest for young companies from all over the European Union. The tenth edition of the competition organized by the European Parliament.",
      7: "Gdańsk, April 8, 2015.<br/>“Pomorskie Sztormy”, Winner of the competition in the Young Company of the Year 2014 category. 10th edition of the Gazeta Wyborcza and the Marshal of the Pomeranian Voivodeship.",
      8: "Gdynia 12.2014.<br/>Leader of the Pomeranian Science and Technology Park in Gdynia. The award was granted by a community of three hundred innovative companies.",
      9: "Gdańsk, October 24, 2014.<br/>Grand Prix Innovation 2014 award. Technikon, 10th Industrial Technology, Science and Innovation Fairs.",
    }
  },
  privacy: {
    title: 'Privacy policy',
    see: 'See more'
  },
  steps: {
    next: "Next step",
    ask: "Ask for more",
    watchVideo: "Watch video",
    learnMore: "Learn more about the product"
  },
  footer: {
    copy: "Copyright <strong>Bioseco</strong>",
    about: "About us",
    contact: "Contact",
    privacy: "Privacy Policy",
    auctions: "Auctions",
    created: "Created in"
  },
  moreAboutUs: "Learn more about us",
  home: {
    headingTopText: "Welcome to Bioseco",
    headingSubText: "We provide solutions for bird protection",
    headingBottomText: "Where would you like to use our products?",
    farms: "Wind farm",
    airports: "Airport",
    area: "Terrain"
  },
  products: {
    headingTopText: 'Our products',
    headingBottomText: 'Choose the place where you need to protect the birds:',
    farms: "Wind farm",
    airports: "Airport",
    area: "Terrain"
  },
  team: [
    {
      name: "Adam Jaworski",
      role: "Chief Executive Officer",
      img: "adam_jaworski.jpg"
    },
    {
      name: "Agnieszka Preś",
      role: "CHIEF FINANCIAL OFFICER",
      img: "agnieszka_pres.jpg"
    },
    {
      name: "Dawid Gradolewski",
      role: "Chief Technology Officer",
      img: "dawid_gradolewski.jpg"
    },
    {
      name: "Damian Dziak",
      role: "Head of Software",
      img: "damian_dziak.jpg"
    },
    {
      name: "Damian Kaniecki",
      role: "Head of Hardware",
      img: "damian_kaniecki.jpg"
    },
    {
      name: "Magda Bielawska",
      role: "Commercial Manager",
      img: "magda_bielawska.jpg"
    },
    {
      name: "Włodek Kulesza",
      role: "HEAD OF R&D",
      img: "wlodek_kulesza.jpg"
    },
    {
      name: "Małgorzata Alboszta",
      role: "HR MANAGER",
      img: "malgorzata_alboszta.jpg"
    },
    {
      name: "Ewelina Lachowicz",
      role: "OPERATIONS MANAGER",
      img: "ewelina_lachowicz.jpg"
    },
    {
      name: "Izabela Szulc",
      role: "MANAGER FOR ISO AND EU PROJECTS",
      img: "izabela_szulc.jpg"
    },
    {
      name: "Maria Giełdon",
      role: "Commercial specialist",
      img: "maria_gieldon.jpg"
    },
    {
      name: "Marcel Pańka",
      role: "Junior Business Developer",
      img: "marcel_panka.jpg"
    },
    {
      name: "Tomasz Jasiński",
      role: "HEAD OF PRODUCTION",
      img: "tomasz_jasinski.jpg"
    },
    {
      name: "Tomasz Spaleniak",
      role: "Logistic Specialist",
      img: "tomasz_spaleniak.jpg"
    },
    {
      name: "Dominik Ambroziak",
      role: "ELECTRONICS ENGINEER/ H&S COORDINATOR",
      img: "dominik_ambroziak.jpg"
    },
    {
      name: "Krzysztof Zakrzewski",
      role: "Assembly Team Leader / Foreman",
      img: "krzysztof_zakrzewski.jpg"
    },
    {
      name: "Bartłomiej Lademan",
      role: "ELECTRONICS SERVICES TECHNICIAN",
      img: "bartlomiej_lademan.jpg"
    },
    {
      name: "Maciej Grzesikiewicz",
      role: "ELECTRONICS SERVICES TECHNICIAN",
      img: "maciej_grzesikiewicz.jpg"
    },
    {
      name: "Arkadiusz Kowalczyk",
      role: "ELECTRONICS SERVICES TECHNICIAN",
      img: "arkadiusz_kowalczyk.jpg"
    },
    {
      name: "Krzysztof Działecki",
      role: "ELECTRONICS SERVICES TECHNICIAN",
      img: "krzysztof_dzialecki.jpg"
    },
    {
      name: "Jakub Pawluk",
      role: "ELECTRONICS SERVICES TECHNICIAN",
      img: "jakub_pawluk.jpg"
    },
    {
      name: "Adam Okun",
      role: "Production foreman",
      img: "adam_okun.jpg"
    },
    {
      name: "Arkadiusz Chojka",
      role: "ELECTRONICS SERVICES TECHNICIAN",
      img: "arkadiusz_chojka.jpg"
    },
    {
      name: "Paweł Hrynkiewicz - Moczulski",
      role: "ELECTRONICS ENGINEER",
      img: "pawel_hrynkiewicz-moczulski.jpg"
    },
    {
      name: "Krzysztof Domozych",
      role: "Data Analyst",
      img: "krzysztof_domozych.jpg"
    },
    {
      name: "Konrad Szwejk",
      role: "Linux Administrator",
      img: "konrad_szwejk.jpg"
    },
    {
      name: "Przemysław Sadkowski",
      role: "Technical Customer Service Manager",
      img: "przemyslaw_sadkowski.jpg"
    },
    {
      name: "Grzegorz Madejski",
      role: "Innovation Manager",
      img: "grzegorz_madejski.jpg"
    },
    {
      name: "Włodzimierz Kaoka",
      role: "Software Development and Implementation Manager",
      img: "wlodzimierz_kaoka.jpg"
    },
    {
      name: "Szymon Witkowski",
      role: "Software Maintenance Manager",
      img: "szymon_witkowski.jpg"
    },
    {
      name: "Łukasz Wittbrodt",
      role: "Applications and Infrastructure Manager",
      img: "lukasz_wittbrodt.jpg"
    },
    {
      name: "Marcin Detlaf",
      role: "FRONT-END DEVELOPER",
      img: "marcin_detlaf.jpg"
    },
    {
      name: "Ilona Konop",
      role: "Data Analyst",
      img: "ilona_konop.jpg"
    },
    {
      name: "Jakub Swenda",
      role: "JUNIOR DATA ANALYST",
      img: "jakub_swenda.jpg"
    },
    {
      name: "Sebastian Zbytniewski",
      role: "Junior R&D Data Analyst",
      img: "sebastian_zbytniewski.jpg"
    },
    {
      name: "Aleksy Stocki",
      role: "Junior R&D Data Analyst",
      img: "aleksy_stocki.jpg"
    },
  ],
  about: {
    hedingTopText: '<strong>Innovation</strong><br />for bird monitoring',
    hedingSubText: '',
    headingText: 'Bioseco was established in April <strong>2013</strong> by a team of optical, radar and computer specialists to develop a system that monitors and protects birds',
    headSectionTopText: 'Why our<br /><strong>solutions?</strong><div class="line"></div>',
    headSectionText: 'The company works closely with ornithologists, chiropterologists and wind farm operators.  Over these years Bioseco has refined and optimised an innovative and cost-effective system that protects birds from colliding with wind turbines.',
    ourCertsTitle: 'Our<br /> <strong>certificates</strong>',
    ourTeamTitle: 'Our<br /><strong>team</strong><div class="line"></div>',
    ourTeamText: 'The Bioseco team is a group of IT engineers, ornithologists, chiropterologists and other people focused on avifauna. We are co-operating with institutions like Instytut Morski (Marine Institute) in Gdańsk, Pomorski Park Naukowo-Technologiczny (Pomeranian Science and Technology Park) in Gdynia, Technopark Gliwice and ornithological organisations. Company goal is to create devices and tools for authoritative research of environment, with wide practical application.',
    ourClientsTitle: 'Our clients',
    personOne: 'Adam Jaworski',
    personOneRole: 'CEO',
    personTwo: 'Dawid Gradolewski',
    personTwoRole: 'CTO',
    personThree: 'Małgorzata Alboszta',
    personThreeRole: 'Analyst',
    personFour: 'Damian Kaniecki',
    personFourRole: 'Designer',
    personFive: 'Paweł Hrynkiewicz',
    personFiveRole: 'Constructor',
    personSixRole: 'Electronics',
    personSeven: 'Damian Dziak',
    personSevenRole: 'Programmer',
    personEight: 'Szymon Witkowski',
    personEightRole: 'Programmer',
    personNine: 'Krzysztof Domozych',
    personNineRole: 'Constructor',
  },
  farmsProducts: {
    headerTopText: '<strong>Solution</strong><br />for Wind Farms',
    headerTopSubText: '',
    headerTopTextPresentation: 'Solution for wind farms',
    headerTopSubTextPresentation: 'Check out how the Bioseco BIRD PROTECTION SYSTEM (BPS) works',
    headerText: 'Every year many birds and bats collide with the wind turbines. To significantly reduce the number of accidents, Bioseco has created a bird protection system.',
    whyOurSolutionText: '',
    whyOurSolution: 'Check out why it is worth to use Bioseco system',
    sectionOneTitle: 'Main assumptions:',
    sectionOneText1: 'System comprised of devices and software, installed on turbines',
    sectionOneText2: 'Estimation of number of birds, recognition of their size and direction of flight',
    sectionOneText3: 'The trigger of specific action: to warn the birds and/or stop the turbine',
    sectionOneText4: 'Creation of the „safety shield”',
    sectionOneText5: 'Collectioning and archiving the data for statistics generation',
    sectionTwoTitle: 'Advantages',
    sectionTwoText1: '<strong class="bolded">Birds protection from the wind turbines</strong>',
    sectionTwoText2: 'Additional advantages',
    sectionTwoText3: 'Avoiding relocation of breeding  grounds and conducting additional surveys',
    sectionTwoText4: 'Collecting valuable data for natural science research',
    sectionThreeTitle: 'Technology',
    sectionThreeText1: 'Non-invasive installation (using existing infrastructure) ',
    sectionThreeText2: 'System which covers the whole wind farm',
    sectionThreeText3: 'Action plan: detectors on the turbines send information to the central unit, where it is analyzed and the proper action may be triggered (e. g. alert/slowdown of the turbine/holdup of the turbine). Data is archivized and transmitted online',
    sectionThreeText4: 'Flexibility of use: adjustment to the user\'s needs and wind farm\'s specifics',
    whyIShouldUseThis: 'Why should I use it?',
    whyIShouldUseThisOneTopBefore: '',
    whyIShouldUseThisOneTop: '314,000',
    whyIShouldUseThisOneTopAfter: '',
    whyIShouldUseThisOneText: 'the number of wind turbines spinning around the world',
    whyIShouldUseThisTwoTopBefore: '$',
    whyIShouldUseThisTwoTop: '109',
    whyIShouldUseThisTwoTopAfter: 'bln',
    whyIShouldUseThisTwoText: 'amount invested in wind power globally',
    whyIShouldUseThisThreeTopBefore: '',
    whyIShouldUseThisThreeTop: '5',
    whyIShouldUseThisThreeTopAfter: 'mln',
    whyIShouldUseThisThreeText: 'birds & bats are killed by wind turbines yearly',
    whyIShouldUseThisFourTopBefore: '',
    whyIShouldUseThisFourTop: '300',
    whyIShouldUseThisFourTopAfter: 'km/h',
    whyIShouldUseThisFourText: 'the speed of blades at the tip, surprising the birds',
  },
  farmsPresentation: {
    title: 'Wind farm - bird collisions',
    steps: [{
      title: "Collision problem",
      text: "Collisions with wind turbines kill millions of birds and bats around the world each year."
    },
      {
        title: "Bioseco's modules",
        text: `The modules are installed on the turbine's monopole with band in the way they encompass 360 degree view. On the turbine there are 4 to 6 detection modules, on the height from 5 to 10 meters above the ground. Each detection module monitors a seperate quadrant.`
      },
      {
        title: "Detection",
        text: "The system detects birds from the distance of 500 meters and analyses their size, flight trajectory and the likelihood of collision."
      },
      {
        title: "Warning lights",
        text: "At the predetermined distance, the system starts displaying bright stroboscopic lights to alert the birds and deter them from the danger ahead."
      },
      {
        title: "Warning sounds",
        text: "Birds that continue their flight on the dangerous trajectory will be subjected to the wailing of warning sounds such as sirens."
      },
      {
        title: "Stopping the turbine",
        text: "The system can be programmed to adjust the turbine's behaviour. For example, if rare or endangered species of birds stay on the collision course, the turbine could be stopped."
      },
      {
        title: "Safely pass",
        text: "Birds that evade collision will be monitored and after they leave the dangerous zone, the turbines will be turned on again."
      },
      {
        title: "Safely pass",
        text: "The system stores detailed records of each incident for later analysis. The full data and statistic tools for the user will be provided.<br/><br/><img src='/static/img/product/desktop.jpg' width='200' style='float: right;'><br/><br/>"
      }
    ]
  },
  airportProducts: {
    headerTopText: '<strong>Innovative system</strong><br />for preventing bird-aircraft collisions',
    headerTopSubText: 'SOLUTION FOR AIRPORTS',
    headerTopTextPresentation: 'Preventing bird-aircraft collisions',
    headerTopSubTextPresentation: 'See how our innovative Bioseco AIRPORT FAUNA MONITORING SYSTEM (AFMS) works',
    headerText: 'With the passenges safety in mind, Bioseco has developed a solution reducing the number of birds colliding with airplanes.',
    whyOurSolutionText: '',
    whyOurSolution: 'Check out why it is worth to use Bioseco system',
    sectionOneTitle: 'Main assumptions',
    sectionOneText1: 'System comprised of devices and software, installed at the airport',
    sectionOneText2: 'Counting the number of birds, recognition of their size and direction of flight',
    sectionOneText3: 'Alerts for airport workers',
    sectionOneText4: 'The trigger of specific action',
    sectionOneText5: 'Collectioning and archiving the data for statistics generation',
    sectionTwoTitle: 'Benefits',
    sectionTwoText1: 'Increased levels of passenger security',
    sectionTwoText2: 'Protection of birds',
    sectionTwoText3: 'Reduction of costs related to the collisions with birds',
    sectionTwoText4: 'Collection of data over the long periods of time and application for various purposes (e.g. planning actions for subsequent migration and breeding seasons)',
    sectionTwoText5: 'Automatization of actions',
    sectionTwoText6: 'Facilitation of tasks for airport workers',
    sectionTwoText7: 'Better relations with airlines',
    sectionTwoText8: 'Argument for reduction of insurance premiums',
    sectionTwoText9: 'Better image of company, that cares about passengers and implements new, innovative technologies',
    sectionTwoText10: '',
    sectionThreeTitle: 'Technology',
    sectionThreeText1: 'Non-invasive installation (using existing infrastructure)',
    sectionThreeText2: 'System which covers important areas at the airport',
    sectionThreeText3: 'Action plan: detectors send information to the central unit, where it is analyzed and the proper action may be triggered. Data is archived and transmitted online',
    sectionThreeText4: 'Solution safe for airport communication, wireless and radio systems',
    sectionThreeText5: 'Flexibility of use: adjustment to the user\'s needs and airport specifics',
    whyIShouldUseThis: 'Why should I use it?',
    whyIShouldUseThisOneTopBefore: '',
    whyIShouldUseThisOneTop: '65,139',
    whyIShouldUseThisOneTopAfter: '',
    whyIShouldUseThisOneText: 'bird strikes have been reported for 2011-14',
    whyIShouldUseThisTwoTopBefore: '',
    whyIShouldUseThisTwoTop: '92',
    whyIShouldUseThisTwoTopAfter: '%',
    whyIShouldUseThisTwoText: 'of strikes occur below 900 m',
    whyIShouldUseThisThreeTopBefore: '',
    whyIShouldUseThisThreeTop: '90',
    whyIShouldUseThisThreeTopAfter: '%',
    whyIShouldUseThisThreeText: 'of bird collisions occur near or on airports',
    whyIShouldUseThisFourTopBefore: '$',
    whyIShouldUseThisFourTop: '1,2',
    whyIShouldUseThisFourTopAfter: 'bln',
    whyIShouldUseThisFourText: 'the cost of birdstrikes to airlines',
  },
  airportPresentation: {
    title: 'Aircraft-bird collisions',
    steps: [
      {
        title: 'Aircraft-bird collisions',
        text: "Aircraft and birds collisions during take off and landing cause over <strong>1.2 billion</strong> US dollars worldwide every year, forcing many flights to return to the airport, delaying flights and putting officers’ lives at risk."
      },
      {
        title: 'Bioseco Airport System',
        text: "The system is installed in all important areas approx. 200 m to the airport runway. Bioseco Airport System detects flocking birds in the radius of 300 meters."
      },
      {
        title: 'Monitoring',
        text: "The system monitors bird activity and the information is sent at the real time to the airport safety officers."
      },
      {
        title: 'Alerting',
        text: "System sends alerts to the security service who take appropriate preventive actions."
      },
      {
        title: 'Software',
        text: "The database system collects information on all events, enabling easy generation of reports and analysis of all events. In addition, information about detected objects in real time is displayed by security service employees on mobile devices."
      },
      {
        title: '360° observation',
        text: "Bioseco Airport System enables 360° observation (depending on the number of modules). The detectors are placed in weatherproof housings resistant to adverse weather conditions."
      },
      {
        title: 'Safe take offs and landings',
        text: "Used signals transmitters do not interfere with airport wireless and communication systems. The Bioseco Airport System is flexible and easily tailored to the specific needs and conditions of each and every airport. The system is minimally invasive and is integrated into existing airport infrastructure."
      }
    ]
  },
  areaProducts: {
    headerTopText: '<strong>Solution</strong><br />for ornithologists',
    headerTopSubText: '',
    headerTopTextPresentation: 'Solution for ornithologists',
    headerTopSubTextPresentation: 'See how our innovative Bioseco BIRD PROTECTION SYSTEM (BPS) works',
    headerText: 'Technologies made by Bioseco are useful at wind farms, airports, but also they can become a great tool for ornithologists. They receive a device which provides very precise, completely reliable and accepted by experts data. Bioseco BIRD PROTECTION SYSTEM (BPS) allows continuous observation and registration of all the information on passing birds. Automaticlly collected data is understandable, undeniable and irremovable.',
    whyOurSolutionText: '',
    whyOurSolution: '',
    sectionOneTitle: 'Main assumptions',
    sectionOneText1: 'Bioseco software allows for real-time analysis and constant access to recorded information via a website or any mobile device.',
    sectionOneText2: 'The great amount of data provides the possibility of comparing various parameters on birds flying over the area. Using Bioseco BIRD PROTECTION SYSTEM (BPS), you may conduct research or prepare an environmental report in a faster and more reliable manner, thanks to the use of cutting-edge IT systems',
    sectionTwoTitle: 'How does it work?',
    sectionTwoText1: 'detection of passing birds within a 300 m radius',
    sectionTwoText2: 'Main characteristics of Bioseco BIRD PROTECTION SYSTEM (BPS):',
    sectionTwoText3: 'determination of height, the speed of flight and the distance from the device',
    sectionTwoText4: 'registration of environmental and meteorological data at certain date and hour',
    sectionTwoText5: 'compact device capable of operating in any terrain: in forests, mountains or at the sea',
    sectionTwoText6: 'records video in HD quality, 24h',
    sectionTwoText7: '',
    whyIShouldUseThis: 'Why should I use it?',
    whyIShouldUseThisOneTopBefore: '',
    whyIShouldUseThisOneTop: '450',
    whyIShouldUseThisOneTopAfter: '',
    whyIShouldUseThisOneText: 'bird species in Poland',
    whyIShouldUseThisTwoTopBefore: '',
    whyIShouldUseThisTwoTop: '26',
    whyIShouldUseThisTwoTopAfter: '',
    whyIShouldUseThisTwoText: 'species of bats in Poland',
    whyIShouldUseThisThreeTopBefore: '',
    whyIShouldUseThisThreeTop: '10000',
    whyIShouldUseThisThreeTopAfter: 'km',
    whyIShouldUseThisThreeText: 'storks pass during migration',
    whyIShouldUseThisFourTopBefore: '',
    whyIShouldUseThisFourTop: '5000',
    whyIShouldUseThisFourTopAfter: '',
    whyIShouldUseThisFourText: 'birdwatchers in Poland',
  },
  areaPresentation: {
    title: 'Rozwiązanie dla ornitologów',
    steps: [{
      title: "Environmental surveys",
      text: "Bioseco BIRD PROTECTION SYSTEM (BPS) is a perfect tool for bird monitoring. It can detect birds even from distance of 500 meteres, collecting data on height, speed and direction of their flight. Received data is reilable, precise and acceptable by officers."
    }
    ]
  },
  contact: {
    stayInContact: "Contact Us",
    newBuilding: '(PPNT building)',
    haveQuestions: 'Questions? Feel free to ask',
    pl: 'Poland',
    street: '68 Budowlanych Street',
    account: 'bank account number',
    project: 'Projects co-financed by the EU'
  },
  component: {
    moreAboutUs: 'Learn more',
    watchPresentation: 'Watch the presentation',
    watchVideo: 'See the video',
    watchPromoVideo: 'Watch the promotional video',
    watchBooklet: 'Download the booklet',
    watchExampleVideo: 'See real example of BPS in action',
    bookletPolish: 'Polish',
    bookletEnglish: 'English',
    bookletDeutch: 'Deutch',
    bookletFrench: 'French',
    bookletJapanese: 'Japanese',
    watchUs: 'See us<br /><strong>in action</strong>',
    moreInfo: 'Do you need more information?',
    askAboutMore: 'Ask for more'
  },
  questionModal: {
    haveQuestion: 'Do you have a question?',
    completeForm: 'Fill out the form below, we will be happy to answer:',
    name: 'Name',
    email: 'E-mail address',
    queryTopicText: 'Select the subject of the query',
    queryTopic: {
      questionOne: 'Products for Wind Farms',
      questionTwo: 'Products for Airports',
      questionThree: 'Products for ornithologists',
      questionFour: 'Cooperation',
      questionFive: 'General query'
    },
    content: 'message',
    errorMsg: 'Complete the missing fields',
    errorSendMsg: 'Error while sending',
    sendMsg: 'The form has been sent',
    send: 'Send',
    rodo: `The controller of your personal data disclosed in the above contact form is  Bioseco SA, with its registered office in Gdańsk (80-298), at 68 Budowlanych Street.
           The personal data disclosed in this form will be processed for the purpose of handling your inquiry based on the controller's legitimate interest, i.e., Article 6(1)(f) of the GDPR, consisting in ensuring the quality of its services and communication. You have the right to request access to your personal data, its rectification, erasure, or restriction of processing.
           You also have the right to object to the processing of your personal data and the right to lodge a complaint with the supervisory authority – the President of the Personal Data Protection Office. More information on the processing of your personal data can be found in our Privacy Policy available at: `,
    rodoLink: 'Privacy Policy',
  },
  mediaBox: {
    title: "Media about us",
    mediaBoxes: [
      {
        img: "/static/img/media/img1.jpg",
        title: "GAZETA WYBORCZA",
        text: "the main daily newspaper, article about system for wind farms <span class=arrow></span>",
        link: "http://wyborcza.biz/biznes/1,147584,20695368,bioseco-odstrasza-ptaki-a-przyciaga-inwestorow.html",
        type: "text-type"
      },
      {
        img: "/static/img/media/img4.jpg",
        title: "PULS BIZNESU",
        text: "a leading business daily newspaper, article about system in Gdansk airport <span class=arrow></span>",
        link: "http://pulsbiznesu.pb.pl/3867943,56421,bioseco-ochroni-samoloty-przed-ptakami",
        type: "text-type"
      },
      {
        img: "/static/img/media/img7.jpg",
        title: "TVN24",
        text: "news television, information about cooperation Bioseco and PGE SA <span class=arrow></span>",
        link: "http://tvn24bis.pl/z-kraju,74/powstaje-system-do-monitorowania-ptakow-w-poblizy-farm-wiatrowych,517386.html",
        type: "video-type"
      },
      {
        img: "/static/img/media/img5.jpg",
        title: "PGE SA",
        text: "company website, statement on cooperation with Bioseco <span class=arrow></span>",
        link: "http://www.gkpge.pl/biuro-prasowe/komunikaty-prasowe/inne/multirejestratory-beda-monitorowac-ptaki-na-terenie-farm-wiatrowych-pge",
        type: "text-type"
      },

    ]
  },
  media: {
    description: "See Us in action",
  },
  infoBox: {
    title: "Media About Us",
    newsTitle: "News",
    archiveTitle: "Archive",
    linkDescription: "Read more : ",
    postedDescription: "Posted: ",
    infoBoxes: [
      {
        img: "/static/img/media/Bioseco_RFQ.png",
        title: "Invitation to submit offers. Request for quotation no PMT/4/2021.",
        text: "Bioseco invites interested parties to submit offers for the RFQ no. PMT/4/2021 carried out under the Polish Tech Bridges program organized by the Polish Investment and Trade Agency, under the Smart Growth Operational Programme 2014-2020, Axis III Support for innovation in enterprises, 3.3 Support for promotion and internationalization of innovating enterprise, 3.3.1 Polish Tech Bridges. A detailed description of the subject of activities and specifications of the services requested can be found in the attachment.  <br/><br /> Attachment: <a download href='/static/RFQ_PMT.4.2021_Bioseco.docx.pdf'>RFQ_PMT.4.2021_Bioseco.pdf</a>",
        type: "text-type",
        date: "02.04.2021"
      },
      {
        img: "/static/img/media/Bioseco_RFQ.png",
        title: "Selection of the offer. Request for quotation no PMT/1/2021.",
        text: "Bioseco chose the best offer for the RFQ no. PMT/1/2021 carried out under the Polish Tech Bridges program organized by the Polish Investment and Trade Agency, under the Smart Growth Operational Programme 2014-2020, Axis III Support for innovation in enterprises, 3.3 Support for promotion and internationalization of innovating enterprise, 3.3.1 Polish Tech Bridges. The chosen offer was submitted by the American Wind Wildlife Institute (AWWI), based in Washingotn DC, USA (1990 K Street NW, 20006), with a contract of $8,850.51.<br/><br /><img src='/static/img/RFQ_PMT.1.2021_Bioseco.png' alt='RFQ_PMT'/>",
        type: "text-type",
        date: "03.02.2021"
      },
      {
        img: "/static/img/media/Bioseco_RFQ.png",
        title: "Invitation to submit offers. Request for quotation no PMT/1/2021.",
        text: "Bioseco invites interested parties to submit offers for the RFQ no. PMT/1/2021 carried out under the Polish Tech Bridges program organized by the Polish Investment and Trade Agency, under the Smart Growth Operational Programme 2014-2020, Axis III Support for innovation in enterprises, 3.3 Support for promotion and internationalization of innovating enterprise, 3.3.1 Polish Tech Bridges. A detailed description of the subject of activities and specifications of the services requested can be found in the attachment.<br/><br /><img src='/static/img/RFQ_PMT.1.2021_Bioseco.png' alt='RFQ_PMT'/><br/><br /> Attachment: <a download href='/static/RFQ_PMT.1.2021_Bioseco.pdf'>RFQ_PMT.1.2021_Bioseco.pdf</a> ",
        type: "text-type",
        date: "22.01.2021"
      },
      {
        img: "/static/img/media/spain_december.jpg",
        title: "Another system in Spain.",
        text: "We have just installed bird protection systems in the Cadiz area. The system operates on a wind farm where monitoring was carried out stationary by observers. In the case of bird migration, they manually sent a signal to stop the turbine.",
        type: "text-type",
        date: "17.12.2020"
      },
      {
        img: "/static/img/media/bioseco_france.jpg",
        title: "We have entered a new market – France!",
        text: "This week, we installed 3 Bioseco Bird Protection Systems in France.\n" +
          "We are glad such a company as WPO decided to protect birds with Bioseco systems. For the first time our devices are working on Gamesa turbines.\n" +
          "Stereovision enabling distance estimation and bird size classification plus false positive filtering powered by AI shall reduce unnecessary turbine stops and loss of generation to minimum.",
        type: "text-type",
        date: "23.11.2020"
      },
      {
        img: "/static/img/media/mosty_technologiczne.jpg",
        title: "Bioseco got a grant from Polish Investment&Trade Agency",
        text: "PMT is a project supporting the expansion of the Polish SME sector implemented by the Polish Investment and Trade Agency. The Agency aims to support the promotion and internationalization of polish innovative enterprises. Bioseco was identified as such a company and a grant of PLN 200 000 to explore the US market. ",
        type: "text-type",
        date: "14.11.2020"
      },
      {
        img: "/static/img/media/photonics.jpg",
        title: "Bioseco – winner in the Tech Tour Photonics.",
        text: "Bioseco is among the winners of this year's edition of the Tech Tour Photonics program. In the competition participated innovative companies from all over Europe.",
        type: "text-type",
        date: "02.11.2020"
      },
      {
        img: "/static/img/media/bioseco_kreatywni.jpg",
        title: "2nd place for Bioseco at the Jubilee Gala of the 50 Most Creative People in Business!",
        text: "Co-founder of Bioseco, Krzysztof Paszek took second place in the competition held in Warsaw under the patronage of the Ministry of Development and many well-known companies and institutions such as: PKN ORLEN S.A., Millennium Leasing, LOTTE Wedel, Google for Startups, the National Chamber of Commerce.",
        type: "text-type",
        date: "28.09.2020"
      },
      {
        img: "/static/img/media/bioseco_ce.jpg",
        title: "CE certificate",
        text: "We are happy to inform that during rigorous testing our Bird Protection System proved to be in line with EU requirements for electrical equipment, hence we issued EU declaration of conformity and can now issue CE marking on our BPS.",
        type: "text-type",
        date: "01.09.2020"
      },
      {
        img: "/static/img/media/photo_cooperation.jpg",
        title: "Bioseco enters Austrian market by entering into agreement with Energiewerkstatt",
        text: "Lately Bioseco + Windhunter + Energiewerkstatt agreed for the marketing of Bioseco Bird Protection System in Austria. Last week Florian Lachinger (Energiewerkstatt) and Maciej Łaz (Windhunter Service) visited Bioseco offices. Later we went to see Bioseco system in operation at real wind farm. We cross fingers that this cooperation gives good fruits to all Parties engaged with ultimate benefit to the bird protection.",
        date: "30.07.2020"
      },
      {
        img: "/static/img/media/gwo.jpg",
        title: "Bioseco team trained to GWO standards by Windhunter",
        text: "Bioseco installation and technical team was recently trained by our Partner - Windhunter according to GWO standards. <br/>While scaling up activities we need to remember to ensure safety and highest standards of operations. ",
        type: "text-type",
        date: "21.07.2020"
      },
      {
        img: "/static/img/media/bps_germany.jpg",
        title: "Cooperation with BayWa r.e., Germany",
        text: "Bioseco installed two of its Bird Protection Systems for a pilot project in Germany with the large wind farm developer and operator BayWa r.e.\n" +
          "Both parties have high expectations about a high level of bird protection while reducing energy outages due to long-lasting unnecessary stoppages.\n" +
          "Both Bioseco and BayWa r.e. are looking forward to the results of this test campaign in order to contribute to the current discussion in Germany, about necessary features and parameters required to detect and save flocking birds.",
        type: "text-type",
        date: "15.05.2020"
      },
      {
        img: "/static/img/media/wspolpraca-pgeeo.jpg",
        video: "/static/video/bird_tracking.mp4",
        poster: "/static/video/poster_bird_tracking.png",
        title: "Perfect detection registered in Germany.",
        text: "Recently we have successfully installed 2 brand new Bird Protection Systems in Germany with upgraded software.<br/> Not long after the installation our system registered a perfect medium size bird detection. <br/>See the capabilities of our BPS.",
        type: "text-type",
        date: "04.06.2020"
      },
      {
        img: "/static/img/media/installation.jpg",
        title: "Test with PGE EO started ",
        video: "/static/video/Bioseco_ENG_small.mp4",
        poster: "/static/video/poster.png",
        text: "Despite the coronavirus, we at Bioseco are continuing our mission of saving birds at wind farms and protecting owners from negative consequences of bird collisions. If you have a minute please see a short movie from our latest installation in Poland at one of largest Polish wind farms, where we installed our newest eight module Bird Protection System. \n" +
          "<br/>New installations coming up in May 2020, this time in Germany.\n" +
          "<br/>Wish you all good health.",
        type: "text-type",
        date: "20.03.2020"
      },
      {
        img: "/static/img/media/wfo2020.png",
        title: "Bioseco participates in 4th Wind Farm Operators Forum",
        text: "Bioseco participated in 4th Wind Farm Operators Forum in Sopot (www.wfof.eu). Apart from exhibiting the Bird Protection System in mini-fair, our CEO – Adam Jaworski gave a presentation during workshop session on details of Bioseco system. The workshop was co-hosted with Michał Kaczerowski from Ambiens – an experienced environmental consultancy. \n" +
          "<br/>For interested persons there is a chance to receive the presentation and the video from the workshop. Just write at offers@bioseco.com",
        type: "text-type",
        date: "12.03.2020"
      },
      {
        img: "/static/img/media/test2020.jpg",
        title: "Great results of BPS evaluation test in Germany.",
        text: "Another great news regarding Bioseco Bird Protection System. \n" +
          "We have received an evaluation report from Vogelwarte from test campaign performed in Sept/Oct 2019 in Germany. Our eight module system was tested within NatForWinSent programme organized by ZSW and co-funded by German Government (<a href='https://www.natur-und-erneuerbare.de/projektdatenbank/projekte/natforwinsent-ii/'>https://www.natur-und-erneuerbare.de/projektdatenbank/projekte/natforwinsent-ii/</a>). \n" +
          "<br/>Red Kite detection efficiency reached 97% within 200 meters distance. The cumulative detection efficiency between 0-300meters was at 83% and 64% up to 400m away from the system. \n" +
          "<br/>Another great news was very low false positive rate of 7% of which only 1/3 would actually lead to the turbine stop, which is thanks to our stereovision approach to detection and sophisticated detection algorithms.",
        type: "text-type",
        date: "07.02.2020"
      },
      {
        img: "/static/img/media/xmas.jpg",
        title: "X-mas gift. 2 systems for Poland signed.",
        text: "Great gift for Christmas. We have signed 2 agreements with a Polish wind farm developer for delivery of 2 Bird Protection Systems to its projects in Poland that will be constructed in 2H2020. According to the requirements two Vestas turbines shall be equipped with a system protecting birds and stopping the turbine in case birds come closer than 150m to a wind turbine. We can’t wait to realization of this new assignment and installing more Bioseco systems in Poland.  \n" +
          "<br/>Merry Christmas and a Happy New Year.",
        type: "text-type",
        date: "23.12.2019"
      },
      {
        img: "/static/img/media/reon.jpg",
        title: "Bioseco and REON AG sign partnership for Germany",
        text: "Bioseco and Reon AG signed a cooperation agreement by which REON AG will become an authorized agent of Bioseco in Germany. Given the long-lasting presence of Reon in wind market in Germany, wide network and professional approach this will pave the wave for Bioseco in entering the most important market in Germany. We are looking forward for first results of this cooperation soon.",
        type: "text-type",
        date: "20.12.2019"
      },
      {
        img: "/static/img/media/bird-tests.jpg",
        title: "Another test of BPS – this time using trained falcons",
        text: "3 weeks ago Bioseco system was tested with artificial bird. Last week Bioseco Bird Protection System installed on a wind turbine was tested in Poland using trained Falcons. In all trial passes the system successfully detected the bird and stopped the turbine. Congratulations to the Bioseco team for this major step in project development achieved in 2019.",
        type: "text-type",
        date: "13.12.2019"
      },
      {
        img: "/static/img/media/bird.jpg",
        title: "Bioseco Bird Protection System tested in Spain by global player",
        text: "Wondering what it is? Bioseco system was recently tested in Spain on a wind farm of one of global wind energy operators. For the test, Bioseco system had to detect the drones (UAV) resembling birds as on the picture. The tests went very well confirming high detection efficiency and the ability of the system to estimate the distance between the drone and the wind turbine. This feature is essential for the operator to avoid bird collision and minimize turbine shutdown time. Looking forward to more companies willing to test Bioseco systems with real and artificial birds😊 More good news to come soon",
        type: "text-type",
        date: "03.12.2019"
      },
      {
        img: "/static/img/media/installation.jpg",
        title: "Another installation of Bird Protection System in Poland",
        text: "Last week Bioseco installed the new Bird Protection System (BPS) on a wind turbine in Poland. Another safe turbine for birds, another investor protected against bird mortality risk and big step for Bioseco in entering the market with the BPS. Looking forward to new bird challenges",
        type: "text-type",
        date: "18.10.2019"
      },
      {
        img: "/static/img/media/airports.png",
        title: "PLN 2,6M of EU funds for development of airport system signed",
        text: "We have signed a subsidy agreement with NCBiR (National Center for Research and Development) for the co-financing of a research project named “Carrying out research and development works necessary to develop a new autonomous AIRPORT FAUNA MONITORING SYSTEM (AFMS) reducing the number of collisions between aircraft and birds and mammals”. Within this project Bioseco will develop a fully operational product designed to increase the safety at airports regarding environmental risks management. The Project will be executed between 2020-2022.\n" +
          "<br/>The value of the project is almost PLN 3,5M while the EU subsidy amounts to PLN 2,6M. \n" +
          "<Br/>This way Bioseco is continuing to invest in its second business line devoted to airports safety.",
        type: "text-type",
        date: "30.09.2019"
      },
      {
        img: "/static/img/media/wspolpraca-pgeeo.jpg",
        title: "Cooperation with PGE EO official",
        text: "It is official. PGE EO (the biggest wind energy operator in Poland) will test Bioseco systems on its wind farms. This is a major step towards reducing the impact of wind energy on large birds and for development of Bioseco Bird Protection System . For whole press release (in PL) please visit page below",
        link: "https://pgeeo.pl/Aktualnosci/kamery-i-radary-beda-monitorowac-ptaki",
        type: "text-type",
        date: "04.09.2019"
      },
      {
        img: "/static/img/media/pozytywny.jpg",
        title: "Report of Positive Impact 2019",
        text: "We would like to thank Kozminski Business Hub for presenting our organization in the Startup Report of Positive Impact 2019. This report is a collection of Polish companies that deal with creating value for sustainable development. Bioseco is part of to the group of Startups that are characterized by innovation and great possibilities of growth in their activity.<br /><br />We invite you to read the report.<br/>Information about our company can be found on pages 69-71.",
        link: "http://raportspw.kozminskihub.com/",
        type: "text-type",
        date: "30.04.2019"
      },
      {
        img: "/static/img/media/upgrade.jpg",
        title: "System updating",
        text: "Last week our team updated systems on windfarm located in south of Poland.<br />Six of our modules were changed for new genaration of The Bird Protection System.<br /><br />Updated system is equipped with sound modules with different sounds, from sirens to hunting birds, with regulable volume up to 120dB. It’s visual modules can measure distance from birds and with 3 cameras installed, it will provide high resolution pictures.<br /><br />We are sure that the new System will bring great and measurable effects!",
        link: "https://www.linkedin.com/company/bioseco/",
        type: "text-type",
        date: "05.04.2019"
      },

      {
        img: "/static/img/media/move.jpg",
        title: "Bioseco on the move!",
        text: "Find us on our new location, few minutes from the Gdansk Airport.<br /> Greater space helps us to develop our system and is suitable for our growing organization.<br /> The new adress is <b>Budowlanych 68, Gdańsk</b>.<br /><br />Bioseco is ready to welcome you in our new offices!",
        link: "https://www.linkedin.com/feed/update/urn:li:activity:6523494951689560064",
        type: "text-type",
        date: "29.04.2019"
      },

      {
        img: "/static/img/media/wolves.jpg",
        title: "Wolves summit",
        text: "Wolves Summit was a great succes for Bioseco.<br />Making it to semi finals for Great Pitch Competition was indication of the interest in our organization.<br />Together with wounderful meetings and conversations, the summit helped to develop Bioseco team!",
        link: "https://www.linkedin.com/feed/update/urn:li:activity:6513820388680626176",
        type: "text-type",
        date: "21.04.2019"
      },

      {
        img: "/static/img/media/n_img1.jpg",
        title: "IEEE N3XT® STARS",
        text: "We did it! Bioseco has just become a member of the innovation program created by EUtop50.<br />The organization supports young companies that are involved in creating products and technologies that affect Europe's needs.<br />The organization hosts the IEEE N3XT® STARS event. The choice of winners is determined by innovative products beneficial to humanity, based on engineering, compliant with IEEE standards.<br />We are pleased to announce that Bioseco was awarded in 2018 IEEE N3XT® STARS.<br />Being part of such a prestigious group confirms our belief that our actions will positively influence the world around us.<br />Thank you for the award, which encourages our team to constantly improve!",
        link: "https://entrepreneurship.ieee.org/n3xt-stars/",
        type: "text-type",
        date: "28.01.2019"
      },

      {
        img: "/static/img/media/top50.jpg",
        title: "EUtop50 contest",
        text: "<span class=strong>We've just won the prestigious EUtop50 contest in the European Parliament in Brussels!</span><br /><span class=strong>The EUtop50</span> was organised on the occasion 10th European Innovation Summit and EU Science & Innovation high-level conference. <br /><span class=strong>Bioseco</span> was the only startup representing Poland and one of two representing CEE.<br />This event combines the best European startups, outstanding scientists, politicians, investors and business representatives.<br />The prize confirms that our solution is heading into a good direction of protecting the environment with our innovative technology.<br /><span class=strong>Bioseco team</span> is proud of its mission and solution that we have developed and we are happy to help wind farm operators to protect birds on their sites. ",
        link: "https://www.facebook.com/pg/Bioseco-497515667013273/posts/?ref=page_internal",
        type: "text-type",
        date: "29.11.2018"
      },
      {
        img: "/static/img/media/sonda2.jpg",
        title: "Bioseco innovation presented in the \"Sonda 2\" tv program.",
        text: "The episode of the \"Sonda 2\" program was entirely about birds. It presented a problem of their mortality on wind farms. We were able to tell how we can save the birds from death as a result of a collision with turbine blades. The program was broadcast on TV channel Dwójka.",
        type: "text-type",
        date: "25.05.2018"
      },
      {
        img: "/static/img/media/scale_up.jpg",
        title: "Bioseco takes part in the KPT ScaleUP program in Krakow",
        text: "The Bioseco team, thanks to the participation in the KPT ScaleUP program, was able to establish contacts with representatives of the Krakow Airport, test prototypes, as well as participate in a series of meetings and trainings.",
        type: "text-type",
        date: "05.08.2017"
      },
      {
        img: "/static/img/media/bird-strike.jpg",
        title: "World Birdstrike Association Congress in Amsterdam",
        text: "Bioseco representatives took part in the most important meeting related to birdstrikes at airports area. This is an extremely important issue because it generates losses of over two billion dollars annually. There are organizations and associations that integrate experts on this subject. For Bioseco, it was a valuable learning experience and a chance to meet the most important people from international airports, which will certainly pay off in the future.",
        type: "text-type",
        date: "06.12.2016"
      },
      {
        img: "/static/img/media/kongres.jpg",
        title: "Meetings at Congress 590 in Rzeszów",
        text: "Bioseco was invited to join the group of innovative companies that spoke with government and large companies representatives. Among the people we met was also Bruce Dickinson - the owner of Cardiff Aviation and the vocalist of Iron Maiden.",
        type: "text-type",
        date: "17.11.2016"
      },
      {
        img: "/static/img/media/tedx.jpg",
        title: "Bioseco mission presented at TEDx \"Between species\" - Gdynia",
        text: "It was an honor to introduce to an intellectualists’ audience the issue of bird conservation in wind farms and describe the Bioseco solution. ",
        type: "text-type",
        date: "26.11.2015"
      },
      {
        img: "/static/img/media/innowacje-tvp.jpg",
        title: "Bioseco in the program \"Innowacje dla Ciebie\" on TVP",
        text: "In the popular program \"Innovations for You\", edited by Roman Młodkowski, together with the president of Technopark, prof. Jan Kosmol, Krzysztof Paszek from Bioseco talked about innovations, business support and, above all, presented the concept of the Bioseco solution.",
        type: "text-type",
        date: "17.08.2015"
      },
      {
        img: "/static/img/media/horyzont2020.jpg",
        title: "Bioseco has won the Horizon 2020 grant",
        text: "A consortium of three companies, including Bioseco, won a grant from the Horizon 2020 program, SME Instrument Phase 1. Experts from the European Commission rated the drone detection project so highly that it was among the top ten projects from Poland to which this grant was awarded.",
        type: "text-type",
        date: "10.06.2015"
      },
      {
        img: "/static/img/media/mobile-kongres.jpg",
        title: "Participation in the Mobile World Congress in Barcelona",
        text: "For the second time Bioseco attended as an exhibitor at the famous MWC fairs in Barcelona. Among other innovative companies, Bioseco presented its solution for saving birds on wind farms. The great interest and declarations from future customers confirm the right direction of Bioseco technology development.",
        type: "text-type",
        date: "02.03.2015"
      },
      {
        img: "/static/img/media/counter.jpg",
        title: "The project of detecting and counting cars in city traffic was completed",
        text: "Bioseco has developed a unique monitoring system for counting cars at intersections. The client will use the system to monitor the effectiveness of outdoor advertising media.",
        type: "text-type",
        date: "02.02.2015"
      },
      {
        img: "/static/img/media/sztormy.jpg",
        title: "Our company has won the prestigious “Pomeranian Storm” award",
        text: "Bioseco won in the Young Company of 2014 category in a competition organized by the Marshal of the Pomeranian Region and Gazeta Wyborcza. The high rank of the event was emphasized by the presence of the presidents of Gdynia, Gdańsk and Sopot, and of course the Marshal of the Pomeranian Region. The gala took place at the Shakespeare Theater in Gdańsk.",
        type: "text-type",
        date: "20.12.2014"
      },
      {
        img: "/static/img/media/swiss.jpg",
        title: "Presentation of the Bioseco solution in Switzerland",
        text: "At the Swiss-Polish Roundtable on Innovation, Bioseco representatives presented the concept of the device and the possibilities of a bird monitoring and protection. The topic met with great interest.",
        type: "text-type",
        date: "28.10.2014"
      },
      {
        img: "/static/img/media/lider-ppnt.jpg",
        title: "The Leader of PPNT Gdynia in the category \"Product, service, brand\"",
        text: "Bioseco received “The PPNT Gdynia Leader” award as the most outstanding brand and company in 2014. The entire PPNT Gdynia community, consisting of almost three hundred innovative companies, participated in the plebiscite.",
        type: "text-type",
        date: "20.12.2014"
      },


    ]
  },
  photos: {
    title: "Zobacz nas w akcji",
    images: [
      {
        img: "link do zdjęcia",
        alt: "alt",
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js